import React, { useEffect, useState, useRef } from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import { Toast } from "primereact/toast";
import { useNavigate } from "react-router-dom";
import axios from "axios";

// State name to abbreviation mapping
const STATE_ABBREVIATIONS: Record<string, string> = {
  Alabama: "AL",
  Alaska: "AK",
  Arizona: "AZ",
  Arkansas: "AR",
  California: "CA",
  Colorado: "CO",
  Connecticut: "CT",
  Delaware: "DE",
  Florida: "FL",
  Georgia: "GA",
  Hawaii: "HI",
  Idaho: "ID",
  Illinois: "IL",
  Indiana: "IN",
  Iowa: "IA",
  Kansas: "KS",
  Kentucky: "KY",
  Louisiana: "LA",
  Maine: "ME",
  Maryland: "MD",
  Massachusetts: "MA",
  Michigan: "MI",
  Minnesota: "MN",
  Mississippi: "MS",
  Missouri: "MO",
  Montana: "MT",
  Nebraska: "NE",
  Nevada: "NV",
  "New Hampshire": "NH",
  "New Jersey": "NJ",
  "New Mexico": "NM",
  "New York": "NY",
  "North Carolina": "NC",
  "North Dakota": "ND",
  Ohio: "OH",
  Oklahoma: "OK",
  Oregon: "OR",
  Pennsylvania: "PA",
  "Rhode Island": "RI",
  "South Carolina": "SC",
  "South Dakota": "SD",
  Tennessee: "TN",
  Texas: "TX",
  Utah: "UT",
  Vermont: "VT",
  Virginia: "VA",
  Washington: "WA",
  "West Virginia": "WV",
  Wisconsin: "WI",
  Wyoming: "WY",
};

function ReasonForNoInsuranceField({
  value,
  onChange,
  name = "reasonForNoInsurance",
  state,
}: {
  value: string;
  onChange: (e: React.ChangeEvent<any>) => void;
  name?: string;
  state: string;
}) {
  return (
    <div className="form-group">
      <label>Reason For No Insurance</label>
      <select name={name} className="form-input compact-select" value={value} onChange={onChange}>
        <option value="">Select reason</option>
        {state === "FL" &&
          REASON_FOR_NO_INSURANCE_FLORIDA.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        {state !== "FL" &&
          REASON_FOR_NO_INSURANCE_DEFAULT.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
      </select>
    </div>
  );
}
function PropertyInsuranceField({
  value,
  onChange,
  name = "propertyInsurance",
}: {
  value: string;
  onChange: (e: React.ChangeEvent<any>) => void;
  name?: string;
}) {
  return (
    <div className="form-group">
      <label>Property Insurance</label>
      <select name={name} className="form-input compact-select" value={value} onChange={onChange}>
        <option value="">Select</option>
        <option value="Yes">Yes</option>
        <option value="No">No</option>
      </select>
    </div>
  );
}
function TabActions({ onReset, onSave, saveLoading }: { onReset: () => void; onSave: () => void; saveLoading: boolean }) {
  return (
    <div className="tab-actions">
      {/* <button type="button" className="btn btn-secondary" onClick={onReset}>
        Reset
      </button> */}
      <button type="button" className="btn btn-primary" onClick={onSave} disabled={saveLoading}>
        {saveLoading ? "Saving..." : "Save"}
      </button>
    </div>
  );
}
const RESIDENCE_STATUS = ["Own", "Rent", "Lease"];
const YES_NO_OPTIONS = ["Yes", "No"];
const PRIOR_CARRIERS = [
  "21st CENTURY INS CO OF THE SOUTHWEST",
  "21ST CENTURY INS NATIONAL INS CO. INC",
  "21st CENTURY INSURANCE COMPANY",
  "AAA TEXAS COUNTY MUTUAL INSURANCE CO",
  "ACA INSURANCE COMPANY",
  "ACUITY",
  "AETNA",
  "AFFIRMATIVE INSURANCE COMPANY",
  "AGRICULTURAL WORKERS MUTUAL AUTO INS CO",
  "AIGM",
  "AIU INS CO",
  "ALFA",
  "ALFA VISION INSURANCE CORP",
  "All Other Non Standard Companies",
  "All Other Non Voluntary Companies",
  "All Other Standard Companies",
  "ALLIED AUTO",
  "ALLIED PROPERTY & CASUALTY INS CO",
  "ALLMERICA FINANCIAL ALLIANCE INS CO",
  "ALLSTATE COUNTY MUTUAL INSURANCE CO",
  "ALLSTATE FIRE & CASUALTY INSURANCE CO",
  "ALLSTATE INDEMNITY CO",
  "ALLSTATE INS CO (NOT INDEMNITY)",
  "ALLSTATE PROP AND CAS INS CO",
  "ALPHA PROPERTY & CASUALTY INSURANCE CO",
  "AMCO INS CO",
  "AMERICA FIRST INSURANCE CO",
  "AMERICAN AMBASSADOR",
  "AMERICAN BANKERS INS CO OF FL",
  "AMERICAN COMMERCE INSURANCE CO",
  "AMERICAN ECONOMY INS CO",
  "AMERICAN FAMILY HOME INS CO",
  "AMERICAN FAMILY INS CO",
  "AMERICAN FAMILY MUTUAL",
  "AMERICAN FIRE & CASUALTY COMPANY",
  "AMERICAN HOME ASSURANCE COMPANY",
  "AMERICAN INDEPENDENT",
  "AMERICAN INS CO",
  "AMERICAN INTERNATIONAL INS CO",
  "AMERICAN INTERNATIONAL SOUTH INS CO",
  "AMERICAN MANUFACTURERS MUTUAL INS CO",
  "AMERICAN MERCURY INS CO",
  "AMERICAN MODERN HOME INS CO",
  "AMERICAN NATIONAL COUNTY MUTUAL INS CO",
  "AMERICAN NATIONAL GENERAL INS CO",
  "AMERICAN NATIONAL PROP AND CAS CO",
  "AMERICAN PREMIER INS CO",
  "AMERICAN RELIABLE INS CO",
  "AMERICAN SELECT INS CO",
  "AMERICAN SERVICE INS CO",
  "AMERICAN SERVICE PATRIOT",
  "AMERICAN STANDARD INS",
  "AMERICAN STANDARD INS CO OF OH",
  "AMERICAN STANDARD INS CO OF WI",
  "AMERICAN STATES INS CO",
  "AMERICAN STATES PREFERRED INS CO",
  "AMERICAN UNDERWRITERS INS CO",
  "AMERICAN WESTERN HOME INS CO",
  "AMEX ASSURANCE COMPANY",
  "AMICA MUTUAL INS CO",
  "ASSIGNED RISK PLAN",
  "ATLANTA CASUALTY CO",
  "ATLANTA SPECIALTY INS CO",
  "AUDUBON",
  "AUSTIN MUTUAL INS CO",
  "AUTO CLUB FAMILY INS CO (AAA)",
  "AUTO-OWNERS INS CO",
  "AUTOMOBILE CLUB INTERINSURANCE EXCH-AAA",
  "AUTOMOBILE INS CO OF HARTFORD",
  "BEACON NATIONAL INS CO",
  "BIRMINGHAM FIRE INSURANCE CO OF PA",
  "BOSTON OLD COLONY INS CO",
  "BRISTOL WEST INS CO",
  "BRISTOL WEST/COAST NATIONAL",
  "BUCKEYE STATE MUTUAL INS CO",
  "CALIFORNIA CASUALTY INDEMNITY EXCHANGE",
  "CALIFORNIA CASUALTY INS CO",
  "CAMERON MUTUAL INS CO",
  "CELINA",
  "CENTRAL MUTUAL INS CO",
  "CHARTER OAK FIRE INS CO",
  "CHUBB LLOYDS INS CO OF TX",
  "CIGNA SPECIALTY INS CO",
  "CINCINNATI INS CO",
  "CITIZENS INS CO OF AMERICA",
  "CITIZENS INS CO OF MIDW",
  "CLARENDON",
  "CNA INS CO",
  "CNL INSURANCE",
  "COAST NATIONAL",
  "COLONIAL COUNTY MUTUAL INS CO",
  "COLORADO CASUALTY INS CO",
  "COLORADO FARM BUREAU MUTUAL",
  "COLUMBIA MUTUAL INS CO",
  "COLUMBIA NATIONAL INS CO",
  "CONSUMERS COUNTY MUTUAL INS CO",
  "CONTINENTAL CASUALTY",
  "CONTINENTAL INS CO",
  "CORNERSTONE NATIONAL INS CO",
  "COTTON STATES",
  "COUNTRY MUTUAL INS CO",
  "COUNTRY PREFERRED INS CO",
  "COUNTRYWAY INS CO",
  "DAIRYLAND COUNTY MUTUAL INS CO",
  "DAIRYLAND INS CO",
  "DEERBROOK INS CO",
  "DEPOSITORS INS CO",
  "DIRECT GENERAL INS CO",
  "DIRECT GENERAL INS CO OF MS",
  "DIRECT INSURANCE",
  "ECONOMY PREMIER ASSURANCE",
  "ELECTRIC INS CO",
  "EMCASCO INS CO",
  "EMPIRE FIRE AND MARINE INS CO",
  "EMPLOYERS FIRE INS CO",
  "EMPLOYERS MUTUAL CASUALTY CO",
  "ENCOMPASS INDEMNITY CORP",
  "ENCOMPASS PROPERTY AND CAS CO",
  "EQUITY INS CO",
  "ERIE INSURANCE COMPANY",
  "ERIE INSURANCE EXCHANGE",
  "ESURANCE INS CO",
  "FARMERS INS EXCHANGE",
  "FEDERAL INS CO",
  "FIDELITY AND CASUALTY OF NY",
  "FIREMANS FUND INS CO",
  "FOREMOST INS CO GRAND RAPIDS MI",
  "FOUNDERS INS CO",
  "GEICO CASUALTY CO",
  "GEICO GENERAL INS CO",
  "GEICO INDEMNITY",
  "GREAT AMERICAN INS CO",
  "HARTFORD FIRE INS CO",
  "LIBERTY MUTUAL FIRE INS CO",
  "NATIONAL GENERAL INS",
  "NATIONWIDE MUTUAL INS CO",
  "OHIO CASUALTY INS CO",
  "PROGRESSIVE INSURANCE",
  "SAFECO INS CO OF AMERICA",
  "STATE FARM MUTUAL AUTOMOBILE INS CO",
  "TRAVELERS CASUALTY COMPANY OF CT",
];
const LIABILITY_LIMITS_FLORIDA = [
  "None",
  "No BI/10000",
  "10000/20000/10000",
  "15000/30000/10000",
  "25000/50000/25000",
  "50000/100000/25000",
  "50000/100000/50000",
  "100000/300000/50000",
  "100000/300000/100000",
  "250000/500000/100000",
  "250000/500000/250000",
  "300000/500000/250000",
  "300000/500000/300000",
  "500000/500000/300000",
  "500000/500000/500000",
  "500000/1000000/300000",
  "500000/1000000/500000",
  "1000000/1000000/500000",
  "1000000/1000000/1000000",
  "5000000/5000000/1000000",
  "100000 CSL",
  "300000 CSL",
  "500000 CSL",
];

const LIABILITY_LIMITS_DEFAULT = [
  "None",
  "25000/50000/25000",
  "50000/100000/25000",
  "50000/100000/50000",
  "100000/300000/50000",
  "100000/300000/100000",
  "250000/500000/100000",
  "250000/500000/250000",
  "300000/500000/250000",
  "300000/500000/300000",
  "500000/500000/300000",
  "500000/500000/500000",
  "500000/1000000/300000",
  "500000/1000000/500000",
  "1000000/1000000/500000",
  "1000000/1000000/1000000",
  "5000000/5000000/1000000",
  "100000 CSL",
  "300000 CSL",
  "500000 CSL",
];
const POLICY_TYPE_GEORGIA = ["Standard", "Nonowner", "Broadform"];

const REASON_FOR_NO_INSURANCE_FLORIDA = [
  "No Reason Given",
  "Car In Storage",
  "Company Car",
  "Deployed Military",
  "Did Not Own Vehicle",
  "Driving Without Insurance",
  "Incarcerated",
  "No Insurance Required",
  "Out Of Country",
  "Physically Impaired",
  "Self Insured",
  "Under Others Policy",
  "Other",
];
const REASON_FOR_NO_INSURANCE_DEFAULT = [
  "No Reason Given",
  "Car In Storage",
  "Company Car",
  "Deployed Military",
  "Did Not Own Vehicle",
  "Driving Without Insurance",
  "Incarcerated",
  "No Insurance Required",
  "Out Of Country",
  "Physically Impaired",
  "Self Insured",
  "Under Others Policy",
  "Other",
];

const initialData = {
  policyType: "",
  residentType: "",
  residenceStatus: "",
  timeAtResidenceYears: "",
  timeAtResidenceMonths: "",
  priorInsurance: "",
  priorInsuranceTimeYears: "",
  priorInsuranceTimeMonths: "",
  priorInsuranceCarrier: "",
  priorCarrierId: "",
  priorLiabilityLimits: "",
  serviceMessage: "",
  // identifier: "",
  propertyInsurance: "",
  customerDeclinedCredit: "",
  street2: "",
  reasonForNoInsurance: "",
};

export default function ContactInformationConfig({
  contactConfigurationList,
  state,
  getContactConfigurationDetails,
  loading,
}: {
  contactConfigurationList: any;
  state: string;
  getContactConfigurationDetails: () => void;
  loading: boolean;
}) {
  const [formData, setFormData] = useState(initialData);
  const toast = React.useRef<Toast>(null);
  const navigate = useNavigate();

  const formRef = useRef<HTMLFormElement>(null);
  const [saveLoading, setSaveLoading] = useState(false);
  const [priorCarriers, setPriorCarriers] = useState<Array<{ text: string; values: string }>>(
    PRIOR_CARRIERS.map((name) => ({ text: name, values: "" })),
  );
  const [loadingCarriers, setLoadingCarriers] = useState(false);

  // Determine which liability limits to use based on state

  const liabilityLimits = state === "Florida" ? LIABILITY_LIMITS_FLORIDA : LIABILITY_LIMITS_DEFAULT;

  /** Load API data into form */
  useEffect(() => {
    if (contactConfigurationList) {
      setFormData({
        policyType: contactConfigurationList.policyType ?? "",
        residentType: contactConfigurationList.residentType ?? "",
        residenceStatus: contactConfigurationList.residenceStatus ?? "",
        timeAtResidenceYears: contactConfigurationList.timeAtResidenceYears ?? "",
        timeAtResidenceMonths: contactConfigurationList.timeAtResidenceMonths ?? "",
        priorInsurance: contactConfigurationList.priorInsurance ?? "",
        priorInsuranceTimeYears: contactConfigurationList.priorInsuranceTimeYears ?? "",
        priorInsuranceTimeMonths: contactConfigurationList.priorInsuranceTimeMonths ?? "",
        priorInsuranceCarrier: contactConfigurationList.priorInsuranceCarrier ?? "",
        priorCarrierId: contactConfigurationList.priorCarrierId ?? "",
        priorLiabilityLimits: contactConfigurationList.priorLiabilityLimits ?? "",
        serviceMessage: contactConfigurationList.serviceMessage ?? "",
        // identifier: contactConfigurationList.identifier ?? "",
        propertyInsurance: contactConfigurationList.propertyInsurance ?? "",
        customerDeclinedCredit: contactConfigurationList.customerDeclinedCredit ?? "",
        street2: contactConfigurationList.street2 ?? "",
        reasonForNoInsurance: contactConfigurationList.reasonForNoInsurance ?? "",
      });
    }
  }, [contactConfigurationList]);

  /** Fetch Prior Carriers dynamically based on state */
  useEffect(() => {
    const fetchPriorCarriers = async () => {
      if (!state || state.trim() === "") {
        setPriorCarriers(PRIOR_CARRIERS.map((name) => ({ text: name, values: "" }))); // Use default if no state
        return;
      }

      const stateAbbr = STATE_ABBREVIATIONS[state];
      if (!stateAbbr) {
        setPriorCarriers(PRIOR_CARRIERS.map((name) => ({ text: name, values: "" }))); // Use default if state not found
        return;
      }

      setLoadingCarriers(true);
      try {
        const response = await axios.get(`${process.env.REACT_APP_ACE_API_Url}/api/rate/dropdown/values`, {
          params: {
            state: stateAbbr,
            requestedValue: "Prior_Carriers",
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("igtoken")}`,
          },
        });

        if (response.data?.data && Array.isArray(response.data.data) && response.data.data.length > 0) {
          // Preserve both text and values from API response
          const carriers = response.data.data.map((item: any) => ({
            text: item.text || "",
            values: item.values || "",
          }));
          setPriorCarriers(carriers);
        } else {
          setPriorCarriers(PRIOR_CARRIERS.map((name) => ({ text: name, values: "" }))); // Fallback to default
        }
      } catch (error) {
        console.error("Error fetching prior carriers:", error);
        setPriorCarriers(PRIOR_CARRIERS.map((name) => ({ text: name, values: "" }))); // Fallback to default on error
      } finally {
        setLoadingCarriers(false);
      }
    };

    fetchPriorCarriers();
  }, [state]);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>) => {
    const { name, value } = e.target;
    let clamped = value;
    if (name === "priorInsuranceTimeYears" && value !== "") {
      const n = Math.floor(Number(value));
      clamped = String(Math.min(99, Math.max(0, n)));
    } else if (name === "priorInsuranceTimeMonths" && value !== "") {
      const n = Math.floor(Number(value));
      clamped = String(Math.min(11, Math.max(0, n)));
    } else if (name === "timeAtResidenceYears" && value !== "") {
      const n = Math.floor(Number(value));
      clamped = String(Math.min(99, Math.max(0, n)));
    } else if (name === "timeAtResidenceMonths" && value !== "") {
      const n = Math.floor(Number(value));
      clamped = String(Math.min(11, Math.max(0, n)));
    }
    setFormData((prev) => ({ ...prev, [name]: clamped }));
  };

  const handleReset = () => {
    setFormData(initialData);
  };

  const onContactConfigurationSaveClick = () => {
    if (!state || state.trim() === "") {
      toast.current?.show({
        severity: "warn",
        summary: "Validation Error",
        detail: "State is required.",
        life: 3000,
      });
      return;
    }

    setSaveLoading(true);
    let data = JSON.stringify({
      policyType: formData.policyType,
      residentType: formData.residentType,
      residenceStatus: formData.residenceStatus,
      timeAtResidenceYears: formData.timeAtResidenceYears,
      timeAtResidenceMonths: formData.timeAtResidenceMonths,
      priorInsurance: formData.priorInsurance,
      priorInsuranceTimeYears: formData.priorInsuranceTimeYears,
      priorInsuranceTimeMonths: formData.priorInsuranceTimeMonths,
      priorInsuranceCarrier: formData.priorInsuranceCarrier,
      priorLiabilityLimits: formData.priorLiabilityLimits,
      serviceMessage: formData.serviceMessage,
      // identifier: formData.identifier,
      propertyInsurance: formData.propertyInsurance,
      customerDeclinedCredit: formData.customerDeclinedCredit,
      street2: formData.street2,
      reasonForNoInsurance: formData.reasonForNoInsurance,
      state: state,
    });

    var config = {
      method: "post",
      url: `${process.env.REACT_APP_ACE_API_Url}/api/ace/contactinformationconfiguration`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("igtoken")}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(config)
      .then((response: any) => {
        setSaveLoading(false);
        getContactConfigurationDetails();
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: "Contact configurations saved successfully!",
          life: 3000,
        });
      })
      .catch((error: any) => {
        setSaveLoading(false);
        if (error.response && error.response.status === 401) {
          localStorage.clear();
          navigate("/");
        } else {
          toast.current?.show({
            severity: "error",
            summary: "Error",
            detail:
              error.response && error.response.status
                ? `Error ${error.response.status}: ${error.response.data?.message || "An error occurred while saving the contact configurations!"}`
                : "Unknown error while saving the contact configurations!",
            life: 3000,
          });
        }
      });
  };
  return (
    <div>
      <Toast ref={toast} />

      <div className="config-info-banner">
        <div className="config-info-icon">
          <svg viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
            <line x1="12" y1="8" x2="12" y2="8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            <path d="M12 11v6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </div>
        <div className="config-info-text">
          <p className="feature-bold">Contact Information Settings</p>
          <span className="feature-label">Configure your contact information defaults below.</span>
        </div>
      </div>
      <div style={{ position: "relative" }}>
        {loading && (
          <div className="driver-loading-overlay">
            <div className="driver-loading-content">
              <div className="driver-loading-spinner" />
              <p className="driver-loading-text">Loading contact configuration...</p>
            </div>
          </div>
        )}

        <form ref={formRef}>
          <div
            className="form-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, minmax(220px, 1fr))",
              gap: "1rem",
            }}
          >
            {/* Policy Type */}
            <div className="form-group">
              <label>Policy Type</label>
              <select name="policyType" className="form-input compact-select" value={formData.policyType} onChange={handleChange}>
                <option value="">Select policy type</option>
                <option value="Standard">Standard</option>
                <option value="Nonowner">Nonowner</option>
              </select>
            </div>

            <div className="form-group">
              <label>Customer Declined Credit</label>
              <select
                name="customerDeclinedCredit"
                className="form-input compact-select"
                value={formData.customerDeclinedCredit}
                onChange={handleChange}
              >
                <option value="">Select</option>
                {YES_NO_OPTIONS.map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>

            {/* 2. Residence Status */}

            <div className="form-group">
              <label>
                Residence Type <span className="text-danger">*</span>
              </label>
              <select name="residentType" className={`form-input compact-select `} value={formData.residentType} onChange={handleChange}>
                <option value="">Select residence type</option>
                <option value="Home">Home</option>
                <option value="Apartment">Apartment</option>
                <option value="Condo">Condo</option>
                <option value="Mobile Home">Mobile Home</option>
                <option value="Fixed Mobile Home">Fixed Mobile Home</option>
              </select>
            </div>
            <div className="form-group">
              <label>Residence Status</label>
              <select name="residenceStatus" className="form-input compact-select" value={formData.residenceStatus} onChange={handleChange}>
                <option value="">Select status</option>
                {RESIDENCE_STATUS.map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>
            {/* 3. Time at Residence – Years */}
            <div className="form-group">
              <label>Time at Residence (Years)</label>
              <input
                type="number"
                name="timeAtResidenceYears"
                className="form-input"
                value={formData.timeAtResidenceYears}
                onChange={handleChange}
                min={0}
                max={99}
                step={1}
                placeholder="0–99"
                onKeyDown={(e) => [".", "e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
              />
            </div>

            {/* 4. Time at Residence – Months */}
            <div className="form-group">
              <label>Time at Residence (Months)</label>
              <input
                type="number"
                name="timeAtResidenceMonths"
                className="form-input"
                value={formData.timeAtResidenceMonths}
                onChange={handleChange}
                min={0}
                max={11}
                step={1}
                placeholder="0–11"
                onKeyDown={(e) => [".", "e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
              />
            </div>

            {/* 5. Prior Insurance */}
            <div className="form-group">
              <label>Prior Insurance</label>
              <select name="priorInsurance" className="form-input compact-select" value={formData.priorInsurance} onChange={handleChange}>
                <option value="">Select</option>
                {YES_NO_OPTIONS.map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>

            <ReasonForNoInsuranceField value={formData.reasonForNoInsurance} onChange={handleChange} state={state} />

            {/* 6. Prior Insurance Time – Years */}
            <div className="form-group">
              <label>Time with Prior Insurance (Years)</label>
              <input
                type="number"
                name="priorInsuranceTimeYears"
                className="form-input"
                value={formData.priorInsuranceTimeYears}
                onChange={handleChange}
                min={0}
                max={99}
                step={1}
                placeholder="0–99"
                onKeyDown={(e) => [".", "e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
              />
            </div>

            {/* 7. Prior Insurance Time – Months */}
            <div className="form-group">
              <label>Time with Prior Insurance (Months)</label>
              <input
                type="number"
                name="priorInsuranceTimeMonths"
                className="form-input"
                value={formData.priorInsuranceTimeMonths}
                onChange={handleChange}
                min={0}
                max={11}
                step={1}
                placeholder="0–11"
                onKeyDown={(e) => [".", "e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
              />
            </div>

            {/* 9. Prior Insurance Carrier */}
            <div className="form-group">
              <label>Prior Insurance Carrier</label>
              <select
                name="priorInsuranceCarrier"
                className="form-input compact-select"
                value={formData.priorInsuranceCarrier}
                onChange={(e) => {
                  const selectedText = e.target.value;
                  const selectedCarrier = priorCarriers.find((carrier) => carrier.text === selectedText);
                  setFormData((prev) => ({
                    ...prev,
                    priorInsuranceCarrier: selectedText,
                    priorCarrierId: selectedCarrier?.values || "",
                  }));
                }}
                disabled={loadingCarriers}
              >
                <option value="">{loadingCarriers ? "Loading carriers..." : "Select carrier"}</option>
                {priorCarriers.map((carrier) => (
                  <option key={carrier.text} value={carrier.text}>
                    {carrier.text}
                  </option>
                ))}
              </select>
            </div>

            {/* 10. Prior Liability Limits */}
            <div className="form-group">
              <label>Prior Liability Limits</label>
              <select name="priorLiabilityLimits" className="form-input compact-select" value={formData.priorLiabilityLimits} onChange={handleChange}>
                <option value="">Select limits</option>
                {liabilityLimits.map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>
                        <PropertyInsuranceField value={formData.propertyInsurance} onChange={handleChange} />

          </div>

          <TabActions onReset={handleReset} onSave={onContactConfigurationSaveClick} saveLoading={saveLoading} />
        </form>
      </div>
    </div>
  );
}
